/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import { PagedAsyncIterableIterator } from "@azure/core-paging";
import {
  VerifiedPartner,
  VerifiedPartnersListOptionalParams,
  VerifiedPartnersGetOptionalParams,
  VerifiedPartnersGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a VerifiedPartners. */
export interface VerifiedPartners {
  /**
   * Get a list of all verified partners.
   * @param options The options parameters.
   */
  list(
    options?: VerifiedPartnersListOptionalParams,
  ): PagedAsyncIterableIterator<VerifiedPartner>;
  /**
   * Get properties of a verified partner.
   * @param verifiedPartnerName Name of the verified partner.
   * @param options The options parameters.
   */
  get(
    verifiedPartnerName: string,
    options?: VerifiedPartnersGetOptionalParams,
  ): Promise<VerifiedPartnersGetResponse>;
}
